import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { exportReportSuccess, exportReportFailure } from '../actions';
import { saveAs } from 'file-saver';
import DashboardActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* exportReportData({ payload }) {
  const { data } = payload;
  const url = `${API_BASE_URL}/application-reports/download`;

  const response = yield request({
    method: 'post',
    data,
    url,
  });

  if (response.success) {
    yield put(exportReportSuccess());
    saveAs(response.raw, response.raw.split('/').pop())
  } else {
    yield put(
      exportReportFailure(
        'An error occured. Please reload the page to try again.'
      )
    );

    networkErrorHandler(response?.statusCode, response.message || 'An error occured. Please reload the page to try again.');
  }
}

export function* onExportReport() {
  yield takeLatest(
    DashboardActionTypes.EXPORT_DASHBOARD_START,
    exportReportData
  );
}
